/**
 * @author        quanquan
 * @dateTime      2020-08-10 15:15:06
 * @description
 */

const genActiveRule = routerPrefix => {
  return location => location.pathname.startsWith(routerPrefix)
}

const t = Date.parse(new Date())

const appInfos = process.env.NODE_ENV === 'production'
  ? [ // 生产环境 子应用 配置项
    { name: 'merchant', entry: `/subSystem/merchant/index.html?t=${t}`, href: '/merchant', system: 'merchant' },
    // { name: 'medical', entry: `/subSystem/medical/index.html?t=${t}`, href: '/medical', system: 'medical' },
    // { name: 'honey', entry: `/subSystem/honey/index.html?t=${t}`, href: '/honey', system: 'honey' },
    { name: 'cloud', entry: `/subSystem/cloud/index.html?t=${t}`, href: '/cloud', system: 'cloud_business' },
    // { name: 'hdsec', entry: `/subSystem/hdsec/index.html?t=${t}`, href: '/hdsec', system: 'hdsec_manager' },
    { name: 'commodity', entry: `/subSystem/commodity/index.html?t=${t}`, href: '/commodity', system: 'commodity' }
    // { name: 'marketing', entry: `/subSystem/marketing/index.html?t=${t}`, href: '/marketing', system: 'marketing' }
  ]
  : window.location.hostname === 'localhost'
    ? [ // 本地开发local开发环境 子应用 配置项
      { name: 'merchant', entry: `//localhost:9091?t=${t}`, href: '/merchant', system: 'merchant' },
      //    { name: 'medical', entry: `//localhost:9092?t=${t}`, href: '/medical', system: 'medical' },
      //  { name: 'honey', entry: `//localhost:9093?t=${t}`, href: '/honey', system: 'honey' },
      { name: 'cloud', entry: `//localhost:9094?t=${t}`, href: '/cloud', system: 'cloud_business' },
      // { name: 'hdsec', entry: `//localhost:9095?t=${t}`, href: '/hdsec', system: 'hdsec_manager' },
      { name: 'commodity', entry: `//localhost:9096?t=${t}`, href: '/commodity', system: 'commodity' }
      // { name: 'marketing', entry: `//localhost:9097?t=${t}`, href: '/marketing', system: 'marketing' }
    ]
    : [ // 本地开发ip开发环境 子应用 配置项
      { name: 'merchant', entry: `//${global_ipAddress}:9091?t=${t}`, href: '/merchant', system: 'merchant' },
      { name: 'medical', entry: `//${global_ipAddress}:9092?t=${t}`, href: '/medical', system: 'medical' },
      { name: 'honey', entry: `//${global_ipAddress}:9093?t=${t}`, href: '/honey', system: 'honey' },
      { name: 'cloud', entry: `//${global_ipAddress}:9094?t=${t}`, href: '/cloud', system: 'cloud_business' },
      { name: 'hdsec', entry: `//${global_ipAddress}:9095?t=${t}`, href: '/hdsec', system: 'hdsec_manager' },
      { name: 'commodity', entry: `//${global_ipAddress}:9096?t=${t}`, href: '/commodity', system: 'commodity' },
      { name: 'marketing', entry: `//${global_ipAddress}:9097?t=${t}`, href: '/marketing', system: 'marketing' }
    ]

// 如果 编辑  子应用信息异常 抛出 错误
for (let i = 0; i < appInfos.length; i++) {
  if ('/' + appInfos[i].name !== appInfos[i].href) {
    throw `${appInfos[i].name}子应用: 请保证name字段和href字段 一致 例子 name: merchant href: /merchant`
  } else if (!appInfos[i].entry) {
    throw `${appInfos[i].name}子应用: 请填写 entry字段`
  }
}

export { appInfos, genActiveRule }



// WEBPACK FOOTER //
// ./src/js/module/singleSpa/appInfos.js